"use client";
import cn from "clsx";
import React, { useEffect, useState } from "react";
import { useTranslations } from "next-intl";
import { Text, Flex, Card, Avatar, Box, Skeleton } from "@radix-ui/themes";
import { SectionProps } from "@/components/common/interface/interfaces";
import Link from "next/link";
import { Tooltip } from "antd";
import { appRouterPush, getPrefetch, isAndroidRouter } from "@/util/apputil";
import { useRouter } from "next/navigation";

import Icon from "@/components/common/icon/icon";
import { tooltipColor } from "../list/defaultType";
// import dynamic from "next/dynamic";
// const Icon = dynamic(() => import("@/components/common/icon/icon"), { ssr: false });
// import { Spinner } from "@phosphor-icons/react/dist/ssr/Spinner";
// import { Debug } from "@/util/debug";
export interface IconLinkType {
  icon: string;
  title?: string;
  trans?: string;
  link?: string;
  loading?: boolean;
  active?: boolean;
  iconClassName?: string;
}
//"group-icon block md:inline-block w-[1.5rem] h-[1.5rem] md:w-[2rem] md:h-[2rem] lg:w-[2.5rem] lg:h-[2.5rem] mx-4"
//icon: string,title: string,href: string
export default function SideItem({
  link,
  loading,
  active,
  showIcon,
  props,
}: {
  link: IconLinkType;
  loading?: boolean;
  active?: boolean;
  showIcon?: boolean;
  props?: SectionProps;
}) {
  const t = useTranslations("side");
  const prefetch = getPrefetch();
  const router = useRouter();
  return (
    <Tooltip color={tooltipColor} title={link.trans} classNames={{ root: "sideTooltip md:hidden" }}>
      <Card
        asChild
        variant="ghost"
        className={cn(
          active ? "isActive" : "",
          "main-menu-card screenAnimation inline-block sm:inline-block md:inline-block !m-2 !p-2 lg:!p-4 lg:!m-0 lg:!mb-4 float-left lg:float-none",
        )}
      >
        <Link
          href={props?.pathname + (link.link ?? "/")}
          className="hover:animate-pulse group"
          prefetch={prefetch}
          aria-label={`Side ${link.link}`}
          title={link.trans}
          onClick={
            isAndroidRouter()
              ? (e) => {
                  e.preventDefault();
                  // router.push(props?.pathname + (link.link ?? "/"));
                  appRouterPush(router, props?.pathname + (link.link ?? "/"));
                  // window.location.href = props?.pathname + (link.link ?? "/");
                }
              : undefined
          }
        >
          <Flex align="center" className="main-menu-card-flex md:flex-col lg:flex-row">
            <Skeleton loading={loading}>
              <Icon
                iconType="phosphor"
                iconName={link.icon}
                color={active ? "var(--ci-active-font-color)" : "var(--ci-font-color)"}
                className={cn(link.iconClassName ?? "", "main-menu-card-icon screenAnimation size-8 lg:size-8")}
              />
            </Skeleton>
            <Box className="main-menu-card-textbox screenAnimation">
              <Skeleton loading={loading}>
                <Text
                  as="div"
                  size="2"
                  weight="bold"
                  className="main-menu-card-text screenAnimation hidden md:flex lg:ml-3 md:min-w-12 justify-center lg:justify-start"
                >
                  {link.title && link.title !== "" ? (t(link.title) ?? "") : ""}
                </Text>
              </Skeleton>
            </Box>
          </Flex>
        </Link>
      </Card>
    </Tooltip>
  );
}
